<div class="uk-width-1-1 sidenav">
    <ul class="uk-nav-default uk-nav-center uk-nav-parent-icon" uk-nav>
        <li class="uk-nav-header uk-text-bold" style="padding-top: 40px; padding-bottom: 40px;">Mes alertes</li>
        <li>
            <a href="#">
                <span *ngIf="alert.reservationAlertCount > 0" class="uk-badge">{{ alert.reservationAlertCount }}</span>
                <img class="uk-display-block uk-margin-auto" src="../../../assets/img/vop_reservation.png">
                <span class="description">Fin de réservation</span>
            </a>
        </li>
        <li>
            <a href="#">
                <span *ngIf="alert.reservationAlertCount > 0" class="uk-badge">{{ alert.userAlertCount }}</span>
                <img class="uk-display-block uk-margin-auto" src="../../../assets/img/vop_utilisateur.png">
                <span class="description">Nouveaux utilisateurs</span>
            </a>
        </li>
        <li>
            <a href="#">
                <span *ngIf="alert.reservationAlertCount > 0" class="uk-badge">{{ alert.carAlertCount }}</span>
                <img class="uk-display-block uk-margin-auto" src="../../../assets/img/vop_ressources.png">
                <span class="description">Nouveaux sinistres</span>
            </a>
        </li>
    </ul>
</div>